import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Import your root component


import './App.css'; // Import Tailwind CSS


  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);